import React, { useState, useEffect } from "react";

import SearchButton from "../../../components/buttons/search/search-btn";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import {
  get_resList_list,
  admin_resper_delete,
  get_vendors_list,
  admin_vendor_delete,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx";
import { statusVendorType } from "../../../components/table/store";

export default function View(props) {
  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleAdviserList = () => {
    setIsActive(true);
    get_vendors_list(adminType)
      .then((res) => {
        let tdata = res?.data;

        let searchData = [];
        setdata(tdata ?? []);
        // if (data?.success === true) {
        //   tdata.forEach((item, index) => {
        //     item["slno"] = index + 1;
        //     // searchData.push(item?.expert_manpower);
        //   });
        //   setdata(tdata ?? []);
        // } else {
        //   setdata([]);
        //   //  setIsActive(false);
        // }

        setIsActive(false);
      }).catch((err) => {
        setdata([]);
        setSnackMessage(err?.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);

      })
      .finally(() => {
        setIsActive(false);
      });
  };
  const handleAddNew = (row) => {
    let path = `/resource-add`;
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/vendor-view/${data.id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_vendor_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleAdviserList();
    }
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleDownload = (dt) => {
    let path = `${result}${dt.brochure}`;
    window.open(path, "_blank");
  };
  const handleDownloadReceipt = (dt) => {
    let path = `${result}${dt.reciept}`;
    window.open(path, "_blank");
  };

  const downloadExcel = () => {
    const exportData = data.map((item) => {
      const statusObj = statusVendorType.find((s) => s.id === item.status);
      return {
        Name: item?.name ?? "",
        "Company Name": item?.company_name ?? "",
        "Application Ref No": item?.unique_application_ref_no ?? "",
        "Email": item?.email ?? "",
        "Contact Number": item?.phone ?? "",
        "Alternate Email": item?.alternate_email ?? "",
        "Alternate Phone": item?.alternate_phone ?? "",
        Address: item?.address ?? "",
        "Area Of Operation": item?.area_of_operation ?? "",
        "Company Description": item?.company_description ?? "",
        Status: statusObj ? statusObj.title : "",
        "Created At": item?.created_at
          ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
          : "",
      };
    });

    const workSheet = XLSX.utils.json_to_sheet(exportData);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Vendors");
    XLSX.writeFile(workBook, "Vendors.xlsx");
  };

  useEffect(() => {
    handleAdviserList();
  }, []);

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>Vendors</b>
          </h6>
          <div className="d-flex">
            {data?.length !== 0 && (
              <button
                className="px-2 py-2 search-style border-0 text-white rounded"
                onClick={downloadExcel}
              >
                Download Excel
              </button>
            )}
          </div>
        </div>
        <hr />

        <>
          <CustomTable
            {...props}
            columns={[
              {
                title: "Name",
                field: "name",
              },
              {
                title: "Application Ref No",
                field: "unique_application_ref_no",
              },
              { title: "Contact Number", field: "phone" },
              { title: "Email", field: "email" },
              {
                title: "Status",
                field: "status",
                type: "vendorstatusType",
              },
            ]}
            data={data}
            actions={[
              { type: "view", handleClick: handleView },
              ...(adminType === 2
                ? [{ type: "delete", handleClick: handleDelete }]
                : []),
            ]}
            handleDownload={handleDownload}
            handleDownload2={handleDownloadReceipt}
          />
        </>
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Vendor ?"
          data={activeData}
          message="Are you sure to delete this Vendor?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
